import * as React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "components/bootstrap";
import { Spinner } from "components/common";
import EventDefinitionFormContainer from "components/event-definitions/event-definition-form/EventDefinitionFormContainer";
import DefinitionFormControls from "./DefinitionFormControls";
function DefinitionFormModal({
  eventDefinition = void 0,
  loading = false,
  onClose,
  action = "edit",
  onSubmit,
  onCancel
}) {
  const { t } = useTranslation("enterprise_security_events");
  return /* @__PURE__ */ React.createElement(Modal, { show: true, bsSize: "xlarge", onHide: onClose }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, (eventDefinition == null ? void 0 : eventDefinition.id) ? t("definition_form_modal.edit_event_definition") : t("definition_form_modal.new_event_definition"))), /* @__PURE__ */ React.createElement(Modal.Body, null, loading ? /* @__PURE__ */ React.createElement(Spinner, { text: t("definition_form_modal.loading") }) : /* @__PURE__ */ React.createElement(
    EventDefinitionFormContainer,
    {
      eventDefinition,
      action,
      onCancel,
      formControls: DefinitionFormControls,
      onSubmit
    }
  )));
}
export default DefinitionFormModal;
